import {} from "../value/index.js";
export function walkType(substitution, t) {
    while (t["@kind"] === "Symbol") {
        const found = substitution.get(t.name);
        if (found === undefined) {
            return t;
        }
        else {
            t = found;
        }
    }
    return t;
}
//# sourceMappingURL=walkType.js.map